import './rule.css';

/** a formatted sound changing rule */
export function Rule(props: { children: string }) {
  return <span className='rule'>{props.children}</span>;
}
